<template>
  <vx-card no-shadow>
    <div class="mb-base">
      <div class="form">
        <dx-validation-group ref="validation-group">
          <div class="dx-fieldset">
            <div class="dx-field">
              <div class="dx-field-label">
                {{ this.$t("Profile.NewPassword") }}
              </div>
              <DxTextBox
                class="dx-field-value"
                mode="password"
                :value.sync="newPassword"
              >
                <DxValidator>
                  <DxRequiredRule
                    :message="this.$t('Profile.PasswordRequired')"
                  />
                  <DxStringLengthRule
                    :min="5"
                    :message="$t('Profile.PasswordMinLength')"
                  />
                </DxValidator>
              </DxTextBox>
            </div>
            <div class="dx-field">
              <div class="dx-field-label">
                {{ this.$t("Profile.RepeatPassword") }}
              </div>
              <DxTextBox
                class="dx-field-value"
                mode="password"
                :value.sync="repeatPassword"
              >
                <DxValidator>
                  <DxCompareRule
                    :comparison-target="checkComparison"
                    :message="this.$t('Profile.PasswordsMustMatch')"
                  />
                </DxValidator>
              </DxTextBox>
            </div>
          </div>
          <div class="flex flex-wrap items-center justify-end mt-base">
            <vs-button
              @click="changePassword"
              class="float-right px-4 w-full md:w-auto mt-6"
              >{{ this.$t("Profile.ChangePassword") }}</vs-button
            >
          </div>
        </dx-validation-group>
      </div>
    </div>
  </vx-card>
</template>
<script>
import DxTextBox from 'devextreme-vue/text-box'
import DxButton from 'devextreme-vue/button'
import DxValidationGroup from 'devextreme-vue/validation-group'
import DxValidationSummary from 'devextreme-vue/validation-summary'
import {
  DxValidator,
  DxRequiredRule,
  DxCompareRule,
  DxStringLengthRule,
} from 'devextreme-vue/validator'
import { notifyMixin } from '@/mixins/notifyMixin'
export default {
  mixins: [notifyMixin],
  data () {
    return {
      newPassword: '',
      repeatPassword: '',
    }
  },
  components: {
    DxTextBox,
    DxButton,
    DxValidator,
    DxRequiredRule,
    DxCompareRule,
    DxStringLengthRule,
    DxValidationSummary,
    DxValidationGroup
  },
  methods: {
    checkComparison () {
      return this.newPassword;
    },
    changePassword () {
      const validationGroup = this.$refs["validation-group"].instance
      const result = validationGroup.validate()
      if (result.isValid) {
        this.$vs.loading()
        const payload = {
          newPassword: this.newPassword
        }
        this.$store
          .dispatch(
            'auth/updatePassword',
            payload
          )
          .then(() => {
            this.notifySuccess(this.$t("Profile.PasswordChanged"))
            this.newPassword = ""
            this.repeatPassword = ""
            validationGroup.reset()
            this.$vs.loading.close()
          })
          .catch((error) => {
            const errorMessage = this.$t(`Profile.${error.response.statusText}`)
            this.notifyError(errorMessage)
            this.$vs.loading.close()
          })

      }
    }
  }
}
</script>
